import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["showDefaultFiltersInPopover"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _reduce from 'lodash/reduce';
import _values from 'lodash/values';
import _find from 'lodash/find';

// Utils
import getDataFromResponse from '@tekion/tekion-base/utils/getDataFromResponse';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Services
import * as defaultFilterServices from '@tekion/tekion-base/services/filterServices';

// Mock Data
import FILTER_TYPES_MOCKS, { DEFAULT_FILTER_TYPES } from '../../mocks/sampleFilterTypes';
import { DEFAULT_FILTER_GROUP } from '../../constants/filterSection.filterGroups';

// Helpers
import { getFiltersForApi, getModifiedDefaultFilters, getFiltersFromResponse } from '../../helpers/filterSection.general';

// readers
import filterGroupReader from '../../readers/FilterGroup';
import { getSelectedFilters, getVisibleDefaultFilters, getValidFiltersFromFilterTypes, sanitizeFilterGroupList, isSelectedFilterGroup } from './helpers/withFilterGroups.general';
import getFiltersWithUpdatedDateFilter, { getFilterGroupListWithUpdatedDateFilter } from './helpers/withFilterGroups.dateFilter';
import { getFilterGroups, getDefaultFilterGroup as getDefaultFilterGroupUtil } from './helpers/withFilterGroups.defaultFilter';
import { getVisibleFilterTypesForDialog } from '../../organisms/filterTrigger/filterTrigger.helper';
import { DEFAULT_FILTER_BEHAVIOR } from '../../constants/filterSection.constants';
var INITIAL_STATE = {
  filterGroups: EMPTY_ARRAY,
  loading: true
};
var withFilterGroups = function withFilterGroups(WrappedComponent) {
  var WithFilterGroups = /*#__PURE__*/function (_Component) {
    _inherits(WithFilterGroups, _Component);
    var _super = _createSuper(WithFilterGroups);
    function WithFilterGroups(props) {
      var _this$defaultFilterBe;
      var _this;
      _classCallCheck(this, WithFilterGroups);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var assetType;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              assetType = _this.props.assetType;
              if (assetType) {
                _context.next = 4;
                break;
              }
              _this.handleNoAsset();
              return _context.abrupt("return");
            case 4:
              _this.populateFilterGroups();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
      _defineProperty(_assertThisInitialized(_this), "getGeneralPersistedDefaultFilter", function () {
        var shouldSetInitialSelectedFilters = _this.props.shouldSetInitialSelectedFilters;
        if (!shouldSetInitialSelectedFilters) {
          return _this.getLocallyPersistedDefaultFilter();
        }
        return undefined;
      });
      _defineProperty(_assertThisInitialized(_this), "getPersistedDefaultFilter", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$props, assetType, filterTypes, fetchDefaultFilterValues, response, _ref3, filters, defaultFilters, filtersFromResponse, defaultFiltersWithUpdatedDateFilter;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, assetType = _this$props.assetType, filterTypes = _this$props.filterTypes, fetchDefaultFilterValues = _this$props.fetchDefaultFilterValues;
              _context2.next = 3;
              return fetchDefaultFilterValues(assetType);
            case 3:
              response = _context2.sent;
              _ref3 = getDataFromResponse(response) || EMPTY_OBJECT, filters = _ref3.filters;
              if (filters) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", undefined);
            case 7:
              defaultFilters = getValidFiltersFromFilterTypes(filterTypes, filters);
              filtersFromResponse = getFiltersFromResponse(defaultFilters);
              defaultFiltersWithUpdatedDateFilter = getFiltersWithUpdatedDateFilter(filtersFromResponse, filterTypes);
              return _context2.abrupt("return", defaultFiltersWithUpdatedDateFilter);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })));
      _defineProperty(_assertThisInitialized(_this), "getLocallyPersistedDefaultFilter", function () {
        var defaultFilterValues = _this.props.defaultFilterValues;
        return defaultFilterValues;
      });
      _defineProperty(_assertThisInitialized(_this), "populateFilterGroups", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var defaultFilterBehavior, defaultFilterValueGetter, defaultFilterValue;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              defaultFilterBehavior = _this.props.defaultFilterBehavior;
              defaultFilterValueGetter = _this.defaultFilterBehaviorVsGetter[defaultFilterBehavior] || _noop;
              _context3.next = 4;
              return defaultFilterValueGetter();
            case 4:
              defaultFilterValue = _context3.sent;
              return _context3.abrupt("return", _this.handleFetchFilterGroupList(defaultFilterValue));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })));
      _defineProperty(_assertThisInitialized(_this), "getDefaultFilterValuesFromApp", function (savedDefaultFilters) {
        var selectedFilters = _this.props.selectedFilters;
        if (savedDefaultFilters) return savedDefaultFilters; // can be [] in case of reset done earlier

        return selectedFilters;
      });
      _defineProperty(_assertThisInitialized(_this), "getDefaultFilterGroup", function (isReset) {
        var _this$props2 = _this.props,
          filterTypes = _this$props2.filterTypes,
          defaultFilterTypes = _this$props2.defaultFilterTypes,
          showDefaultFiltersInPopover = _this$props2.showDefaultFiltersInPopover;
        var visibleFilterTypes = getVisibleFilterTypesForDialog(filterTypes);
        var visibleDefaultFilterTypes = getVisibleDefaultFilters(defaultFilterTypes, visibleFilterTypes);
        return getDefaultFilterGroupUtil(visibleDefaultFilterTypes, visibleFilterTypes, showDefaultFiltersInPopover, !isReset ? _this.getDefaultFilterValuesFromApp() : EMPTY_ARRAY);
      });
      _defineProperty(_assertThisInitialized(_this), "handleNoAsset", function () {
        return _this.setState({
          filterGroups: _castArray(_this.getDefaultFilterGroup()),
          loading: false
        });
      });
      /**
       * filterGroupList should come from api
       * savedDefaultFilters is the filters for defaultFilterGroup
       */
      _defineProperty(_assertThisInitialized(_this), "getFilterGroupsWithDefault", function (filterGroupList, savedDefaultFilters) {
        var _this$props3 = _this.props,
          defaultFilterTypes = _this$props3.defaultFilterTypes,
          filterTypes = _this$props3.filterTypes,
          showDefaultFiltersInPopover = _this$props3.showDefaultFiltersInPopover;
        var visibleFilterTypes = getVisibleFilterTypesForDialog(filterTypes);
        var visibleDefaultFilterTypes = getVisibleDefaultFilters(defaultFilterTypes, visibleFilterTypes);
        var filterGroupsWithDefault = getFilterGroups(visibleFilterTypes, visibleDefaultFilterTypes, filterGroupList, showDefaultFiltersInPopover, _this.getDefaultFilterValuesFromApp(savedDefaultFilters));
        return filterGroupsWithDefault;
      });
      _defineProperty(_assertThisInitialized(_this), "handleFetchFilterGroupList", /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(savedDefaultFilters) {
          var _getSelectedFilters;
          var _this$props4, assetType, onFilterApply, defaultFilterBehavior, filterTypes, shouldSetInitialSelectedFilters, applyInitFilter, fetchFilterGroupList, appliedFilterGroup, shouldSetInitialFilterGroupFromProps, response, filterGroupList, selectedFilterGroupId, filterGroups, filterGroupListWithUpdatedDateFilter, selectedFilterGroup, selectedGroupFilters;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _this$props4 = _this.props, assetType = _this$props4.assetType, onFilterApply = _this$props4.onFilterApply, defaultFilterBehavior = _this$props4.defaultFilterBehavior, filterTypes = _this$props4.filterTypes, shouldSetInitialSelectedFilters = _this$props4.shouldSetInitialSelectedFilters, applyInitFilter = _this$props4.applyInitFilter, fetchFilterGroupList = _this$props4.fetchFilterGroupList, appliedFilterGroup = _this$props4.appliedFilterGroup, shouldSetInitialFilterGroupFromProps = _this$props4.shouldSetInitialFilterGroupFromProps;
                _context4.next = 3;
                return fetchFilterGroupList(assetType);
              case 3:
                response = _context4.sent;
                filterGroupList = sanitizeFilterGroupList(getDataFromResponse(response), filterTypes);
                selectedFilterGroupId = shouldSetInitialFilterGroupFromProps ? appliedFilterGroup : (_getSelectedFilters = getSelectedFilters(filterGroupList)) === null || _getSelectedFilters === void 0 ? void 0 : _getSelectedFilters.selectedFilterGroupId;
                filterGroups = _this.getFilterGroupsWithDefault(filterGroupList, savedDefaultFilters); // need to populate filters inside filterGroups before calling onFilterApply
                filterGroupListWithUpdatedDateFilter = getFilterGroupListWithUpdatedDateFilter(filterGroups, filterTypes);
                selectedFilterGroup = _find(filterGroupListWithUpdatedDateFilter, isSelectedFilterGroup(selectedFilterGroupId));
                selectedGroupFilters = filterGroupReader.filters(selectedFilterGroup);
                if (selectedFilterGroupId && shouldSetInitialSelectedFilters) {
                  onFilterApply(selectedGroupFilters, selectedFilterGroupId, {
                    isInitialFilterApply: true
                  });
                  applyInitFilter({
                    selectedGroupFilters: selectedGroupFilters,
                    selectedFilterGroupId: selectedFilterGroupId
                  });
                } else if (defaultFilterBehavior === DEFAULT_FILTER_BEHAVIOR.PERSIST) {
                  onFilterApply(_this.getDefaultFilterValuesFromApp(savedDefaultFilters), DEFAULT_FILTER_GROUP, {
                    isInitialFilterApply: true
                  }); // so that we get selectedFilters set from application
                  applyInitFilter({
                    selectedGroupFilters: _this.getDefaultFilterValuesFromApp(savedDefaultFilters),
                    selectedFilterGroupId: DEFAULT_FILTER_GROUP
                  });
                }
                applyInitFilter(EMPTY_OBJECT);
                _this.setState({
                  filterGroups: filterGroupListWithUpdatedDateFilter,
                  loading: false
                });
              case 13:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x) {
          return _ref5.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "handleFilterGroupsUpdate", function (filterGroups) {
        _this.setState({
          filterGroups: filterGroups
        });
      });
      _defineProperty(_assertThisInitialized(_this), "saveDefaultFilters", function (changedFilters) {
        var filterGroups = _this.state.filterGroups;
        var _this$props5 = _this.props,
          assetType = _this$props5.assetType,
          defaultFilterBehavior = _this$props5.defaultFilterBehavior,
          filterTypes = _this$props5.filterTypes,
          saveDefaultFilters = _this$props5.saveDefaultFilters;
        // eslint-disable-next-line prefer-const
        var _reduce2 = _reduce(filterGroups, function (acc, filterGroup) {
            var id = filterGroup.id;
            // eslint-disable-next-line no-param-reassign
            if (id === DEFAULT_FILTER_GROUP) acc.defaultFilterGroup = filterGroup;else acc.nonDefaultFilterGroups.push(filterGroup);
            return acc;
          }, {
            defaultFilterGroup: {},
            nonDefaultFilterGroups: []
          }),
          defaultFilterGroup = _reduce2.defaultFilterGroup,
          nonDefaultFilterGroups = _reduce2.nonDefaultFilterGroups;
        var filters = [];
        if (_isEmpty(changedFilters)) {
          // reset
          defaultFilterGroup = _this.getDefaultFilterGroup(true);
          filters = _get(defaultFilterGroup, 'filters'); // we can't set [] as we'll lose the structure of default filters
        } else {
          filters = getModifiedDefaultFilters(changedFilters, _get(defaultFilterGroup, 'filters')); // we can't directly set changedFilters coz it might contain lesser filters
          defaultFilterGroup = _objectSpread(_objectSpread({}, defaultFilterGroup), {}, {
            filters: filters
          });
        }
        _this.handleFilterGroupsUpdate([defaultFilterGroup].concat(_toConsumableArray(nonDefaultFilterGroups)));
        if (assetType && defaultFilterBehavior === DEFAULT_FILTER_BEHAVIOR.PERSIST) saveDefaultFilters(assetType, {
          groupId: null,
          filters: getFiltersForApi(filters, filterTypes)
        });
      });
      _this.state = INITIAL_STATE;
      _this.defaultFilterBehaviorVsGetter = (_this$defaultFilterBe = {}, _defineProperty(_this$defaultFilterBe, DEFAULT_FILTER_BEHAVIOR.PERSIST, _this.getPersistedDefaultFilter), _defineProperty(_this$defaultFilterBe, DEFAULT_FILTER_BEHAVIOR.PERSIST_LOCAL, _this.getLocallyPersistedDefaultFilter), _defineProperty(_this$defaultFilterBe, DEFAULT_FILTER_BEHAVIOR.GENERAL, _this.getGeneralPersistedDefaultFilter), _this$defaultFilterBe);
      return _this;
    }
    _createClass(WithFilterGroups, [{
      key: "renderContent",
      value: function renderContent() {
        var filterGroups = this.state.filterGroups;
        var _this$props6 = this.props,
          showDefaultFiltersInPopover = _this$props6.showDefaultFiltersInPopover,
          restProps = _objectWithoutProperties(_this$props6, _excluded);
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
          onFilterGroupModified: this.handleFilterGroupsUpdate,
          filterGroups: filterGroups,
          saveDefaultFilters: this.saveDefaultFilters
        }));
      }
    }, {
      key: "renderLoader",
      value: function renderLoader() {
        var renderLoader = this.props.renderLoader;
        if (renderLoader) return renderLoader();
        return /*#__PURE__*/React.createElement("div", null, __('Loading...'));
      }
    }, {
      key: "render",
      value: function render() {
        var loading = this.state.loading;
        if (loading) {
          return this.renderLoader();
        }
        return this.renderContent();
      }
    }]);
    return WithFilterGroups;
  }(Component);
  WithFilterGroups.propTypes = {
    assetType: PropTypes.string.isRequired,
    defaultFilterTypes: PropTypes.arrayOf(PropTypes.string),
    filterTypes: PropTypes.array,
    selectedFilters: PropTypes.array,
    appliedFilterGroup: PropTypes.string,
    selectedFilterGroup: PropTypes.string,
    showDefaultFiltersInPopover: PropTypes.bool,
    onFilterApply: PropTypes.func,
    defaultFilterBehavior: PropTypes.oneOf(_values(DEFAULT_FILTER_BEHAVIOR)),
    defaultFilterValues: PropTypes.object,
    shouldSetInitialSelectedFilters: PropTypes.bool,
    applyInitFilter: PropTypes.func,
    showSortTrigger: PropTypes.bool,
    applyInitSort: PropTypes.func,
    fetchDefaultFilterValues: PropTypes.func,
    fetchFilterGroupList: PropTypes.func,
    saveDefaultFilters: PropTypes.func,
    shouldSetInitialFilterGroupFromProps: PropTypes.bool,
    shouldSetDefaultFilter: PropTypes.bool,
    renderLoader: PropTypes.func
  };
  WithFilterGroups.defaultProps = {
    defaultFilterTypes: DEFAULT_FILTER_TYPES,
    filterTypes: FILTER_TYPES_MOCKS,
    appliedFilterGroup: DEFAULT_FILTER_GROUP,
    selectedFilterGroup: DEFAULT_FILTER_GROUP,
    showDefaultFiltersInPopover: true,
    onFilterApply: _noop,
    selectedFilters: EMPTY_ARRAY,
    defaultFilterBehavior: DEFAULT_FILTER_BEHAVIOR.GENERAL,
    defaultFilterValues: undefined,
    shouldSetInitialSelectedFilters: true,
    applyInitFilter: _noop,
    showSortTrigger: false,
    applyInitSort: _noop,
    fetchDefaultFilterValues: defaultFilterServices.fetchDefaultFilterValues,
    fetchFilterGroupList: defaultFilterServices.fetchFilterGroupList,
    saveDefaultFilters: defaultFilterServices.saveDefaultFilters,
    shouldSetInitialFilterGroupFromProps: false,
    shouldSetDefaultFilter: false,
    renderLoader: null
  };
  return WithFilterGroups;
};
export default withFilterGroups;